'use client'
import { createContext, ReactNode } from 'react'
import { getBehaviorVerifyModelService } from 'core/service/hk-web/api'

type TContext = {
  (): string
} | null
const CaptchaContext = createContext<TContext>(null)

type TParams = {
  sceneId: string
}

export type TCaptchaResult = {
  captcha_id: string
  captcha_output: string
  gen_time: string
  lot_number: string
  pass_token: string
}

const captchaVerify = ({ sceneId }: TParams) => {
  return getBehaviorVerifyModelService(sceneId)
    .then((data) => {
      return new Promise<TCaptchaResult>((resolve, reject) => {
        // @ts-ignore
        import('core/assets/js/gt4.js')
          .then(() => {
            try {
              const language = window.location.pathname.startsWith('/zh_CN') ? 'zho' : 'eng'
              // @ts-ignore initGeetest4 存在先忽略ts报错
              window.initGeetest4(
                {
                  captchaId: data.data.data.geeTest.captchaId,
                  product: 'bind',
                  language,
                },
                (captchaObj: any) => {
                  captchaObj
                    .onSuccess(() => {
                      let result = captchaObj.getValidate() as TCaptchaResult
                      resolve(result)
                    })
                    .onError(() => {
                      reject(new Error('CaptchaCSSImageError'))
                    })
                    .onClose(() => reject(new Error('CaptchaClose')))
                  captchaObj.showCaptcha()
                },
                reject
              )
            } catch (e) {
              reject(new Error('GeetestInitError'))
            }
          })
          .catch(() => {
            reject(new Error('GeetestCoreLoadError'))
          })
      })
    })
    .catch((err) => {
      throw new Error('BehaviorVerifyServiceError:' + err.message)
    })
}

export default captchaVerify
